let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g4MW9")).then(() => parcelRequire('hjnLm'));